import { inject } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import {
  TrainerExerciseResponse,
  TrainerService,
} from '@thiememeulenhoff/thor-client';
import { firstValueFrom } from 'rxjs';
import {
  toRequestError,
  withRequestStatus,
} from '../_utils/request-status.feature';

type TrainerExerciseState = { exercises: Array<TrainerExerciseResponse> };

export const TrainerExerciseStore = signalStore(
  { providedIn: 'root' },
  withState<TrainerExerciseState>({ exercises: [] }),
  withRequestStatus(),
  withMethods((store, trainerService = inject(TrainerService)) => ({
    async fetchTrainerExercises(arrangementCode: string): Promise<void> {
      patchState(store, { requestStatus: 'loading' });
      try {
        const exercises = await firstValueFrom(
          trainerService.getTrainerExercises({ arrangementCode }),
        );
        patchState(store, { exercises, requestStatus: 'success' });
      } catch (error) {
        patchState(store, { requestStatus: toRequestError(error) });
        throw error;
      }
    },
  })),
);
